import React, { useState } from "react";
import { API_URL, POST_USER_REMIND_PASSWORD } from "../../constants";
import { Link } from "react-router-dom";

import "./ReminderPassword.css";

export const ReminderPassword = (props) => {
  const [email, setEmail] = useState(false);
  const [password, setPassword] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [reminderSuccess, setReminderSuccess] = useState('');

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleChangePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    setLoginError('');
    setReminderSuccess('');
    const data = { email: email };
    fetch(API_URL + POST_USER_REMIND_PASSWORD, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {

        data.error 
          ? setLoginError(data.error)
          : setReminderSuccess(data.success)

      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <div className="Reminder">
      <form>
        <div className="form-group text-left">
          <label htmlFor="exampleInputEmail1">Your user email address</label>
          <input
            type="email"
            onChange={handleChangeEmail}
            className="form-control"
            id="email"
            aria-describedby="emailHelp"
            placeholder="Enter email"
          />
        </div>

        {loginError && <p className="error-message">{loginError}</p> }
        {reminderSuccess && <p className="success-message">{reminderSuccess}</p> }

        <button
          type="submit"
          onClick={(e) => handleSubmitClick(e)}
        >
          Remind password
        </button>
      </form>
      <div className="Login_register-wrapper">        
        <a
          href="/"
          className="RegisterLanding_link"
        >
          Back to login
        </a>
      </div>
    </div>
  );
};